const state = {
  music: false,
  video: true,
  shareModal: false,
};

const getters = {
  getMusic: (state) => state.music,
  getVideo: (state) => state.video,
  getShareModal: (state) => state.shareModal,
};

const actions = {
  musicOn({ commit }) {
    commit("MUSIC_ON");
  },
  musicOff({ commit }) {
    commit("MUSIC_OFF");
  },
  showVideo({ commit }) {
    commit("SHOW_VIDEO");
  },
  hideVideo({ commit }) {
    commit("HIDE_VIDEO");
  },
  showShareModal({ commit }) {
    commit("SHOW_SHARE_MODAL");
  },
  hideShareModal({ commit }) {
    commit("HIDE_SHARE_MODAL");
  },
};

const mutations = {
  MUSIC_ON(state) {
    state.music = true;
  },
  MUSIC_OFF(state) {
    state.music = false;
  },
  SHOW_VIDEO(state) {
    state.video = true;
  },
  HIDE_VIDEO(state) {
    state.video = false;
  },
  SHOW_SHARE_MODAL(state) {
    state.shareModal = true;
  },
  HIDE_SHARE_MODAL(state) {
    state.shareModal = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
